import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import anscart from './anscart';
export default new Vuex.Store({
    modules:{
        anscart
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js